import React from 'react';
import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';
import {
    alternativeMinimumTaxUtil,
    capitalGainsUtil,
    distributionScheduleUtil,
    dividendPaymentsUtil
} from './util';

import styles from './DistributionHistory.css';
import {
    ALTERNATIVE_MINIMUM_TAX,
    CAPITAL_GAINS,
    DISTRIBUTION_SCHEDULE,
    DIVIDENDS_PAYMENTS
} from './queries';

const DistributionHistory = (props) => {
    const { ticker, moneyMarket, bond, taxFree } = props;
    return (
        <div className="section-container">
            <Card addOverflow>
                <TitleWithDescription title="Distribution History" />

                <div className="card-section dividends">
                    <GqlQueryWrapper
                        query={DIVIDENDS_PAYMENTS}
                        dataFunc={dividendPaymentsUtil(ticker)}
                        variables={{ ticker }}
                        placeholder={() => <TablePreRender height="100px" />}
                    >
                        {({ data: { data, headers } }) => (
                            <React.Fragment>
                                <TitleWithDescription title="Dividends" />
                                <Table data={{ data, headers }} />
                            </React.Fragment>
                        )}
                    </GqlQueryWrapper>
                </div>
                <div className="card-section distribution-schedule">
                    <GqlQueryWrapper
                        query={DISTRIBUTION_SCHEDULE}
                        variables={{ ticker }}
                        dataFunc={distributionScheduleUtil}
                        placeholder={() => <TablePreRender height="100px" />}
                    >
                        {({ data: { data, title } }) => (
                            <React.Fragment>
                                <TitleWithDescription title={title} />
                                <Table rowBars data={{ data }} />
                            </React.Fragment>
                        )}
                    </GqlQueryWrapper>
                    <div className="disclaimer">* If applicable</div>
                </div>

                <GqlQueryWrapper
                    query={CAPITAL_GAINS}
                    dataFunc={capitalGainsUtil}
                    variables={{ ticker }}
                    placeholder={() => <TablePreRender height="100px" />}
                >
                    {({ data: { data, headers, title } }) => (
                        <React.Fragment>
                            {data.length !== 0 && (
                                <div className="card-section capital-gains">
                                    <React.Fragment>
                                        <TitleWithDescription title={title} />
                                        <Table data={{ data, headers }} />
                                    </React.Fragment>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </GqlQueryWrapper>

                {taxFree &&
                    (moneyMarket || bond) && (
                        <div className="card-section alternative-minimum-tax">
                            <React.Fragment>
                                <GqlQueryWrapper
                                    query={ALTERNATIVE_MINIMUM_TAX}
                                    dataFunc={alternativeMinimumTaxUtil}
                                    variables={{ ticker }}
                                    placeholder={() => (
                                        <TablePreRender height="100px" />
                                    )}
                                >
                                    {({ data: { data, asOfDate } }) => (
                                        <React.Fragment>
                                            <TitleWithDescription
                                                title="Alternative Minimum Tax*"
                                                rightText={() =>
                                                    `As of ${asOfDate}`
                                                }
                                                borderLine
                                            />
                                            <Table data={{ data }} />
                                        </React.Fragment>
                                    )}
                                </GqlQueryWrapper>
                                <div className="disclaimer">
                                    *Alternative minimum tax (AMT) percentage
                                    provided here represents the fund&apos;s
                                    estimate of income subject to the AMT as of
                                    the date indicated. This percentage is
                                    subject to change throughout the year and
                                    does not necessarily indicate the final
                                    amount of income that will be subject to
                                    AMT. The current AMT percentage should not
                                    be used for tax return preparation or other
                                    tax filings. T. Rowe Price will provide fund
                                    account holders with a final AMT percentage
                                    in January.
                                </div>
                            </React.Fragment>
                        </div>
                    )}
            </Card>
            <style jsx>{styles}</style>
        </div>
    );
};

export default DistributionHistory;
